module.exports = __webpack_public_path__ + "static/media/ic_menu.4e10f85b.svg";